import { render, staticRenderFns } from "./organizationEdit.vue?vue&type=template&id=8fa11194&"
import script from "./organizationEdit.vue?vue&type=script&lang=js&"
export * from "./organizationEdit.vue?vue&type=script&lang=js&"
import style0 from "./organizationEdit.vue?vue&type=style&index=0&id=8fa11194&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports